export const LEGAL_DETAILS = {
  companyName: 'METERIS',
  contactEmail: 'contact@meteris.fr',
  website: 'https://meteris.fr',
  updatedAt: {
    privacy: '10 mars 2026',
    terms: '9 mars 2026',
    cookies: '10 mars 2026',
  },
};

export default LEGAL_DETAILS;
